// extracted by mini-css-extract-plugin
export default {"advertDetailHeader":"c-j_gv"};